import { makeStyles } from 'tss-react/mui'

export const useVmPlanRowStyles = makeStyles()(theme => ({
  trashIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(2.5),
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
  },
}))
